<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <template v-if="hasChildren(dictOptions)">
        <template v-if="disabled">
          <template v-if="isCustomPannel">
            <component :is="option.dictCode + 'Pannel'" :params="pannelParams">
              <template slot="info">
                {{ findTreeSelectLabel(data, dictOptions) }}
              </template>
            </component>
          </template>
          <span v-else class="text-primary">{{
            findTreeSelectLabel(data, dictOptions)
          }}</span>
        </template>
        <tree-select
          v-else
          v-model="data"
          show-search
          :allow-clear="allowClear"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="dictOptions"
          :filter-tree-node="filterOption"
          :placeholder="
            option.placeholder
              ? option.placeholder
              : $t('_components.placeholder.input') + label
          "
        />
      </template>
      <template v-else>
        <template v-if="disabled">
          <template v-if="staffInfo">
            <staff-info :ids="data" :option="staffInfo" />
          </template>
          <template v-else-if="isCustomPannel">
            <component :is="option.dictCode + 'Pannel'" :params="pannelParams">
              {{ findSelectLabel(data, dictOptions) }}
            </component>
          </template>
          <span v-else class="text-primary">{{
            findSelectLabel(data, dictOptions)
          }}</span>
        </template>
        <!-- <v-select
        v-else
        v-model="data"
        :disabled="disabled"
        :placeholder="$t('_components.placeholder.select')+label"
        label="label"
        value="value"
        :options="dictOptions"
      /> -->
        <!-- <v-select
          v-else-if="multiple"
          v-model="data"
          multiple
          label="label"
          :placeholder="option.placeholder? option.placeholder : $t('_components.placeholder.input')+label"
          :reduce="(option) => option.value"
          :options="dictOptions"
        /> -->
        <a-select
          v-else-if="option.isPlaceholder === 'false'"
          show-search
          style="width: 100%;"
          :mode="multiple ? 'multiple' : 'default'"
          :allow-clear="allowClear"
          :value="data"
          :disabled="disabled"
          :filter-option="filterOption"
          @change="handleChange"
        >
          <a-select-option
            v-for="item in dictOptions"
            :key="item.value"
            :value="item.value"
            :title="item.label"
            :disabled="item.disabled"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div v-else>
          <a-select
            show-search
            style="width: 100%;"
            :mode="multiple ? 'multiple' : 'default'"
            :allow-clear="allowClear"
            :value="data"
            :disabled="disabled"
            :placeholder="
              option.placeholder
                ? option.placeholder
                : $t('_components.placeholder.input') + label
            "
            :filter-option="filterOption"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in dictOptions"
              :key="item.value"
              :value="item.value"
              :title="item.label"
              :disabled="item.disabled"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
          <div v-if="label === 'Vacation Info'" class="vacationTip">
            <div
              v-for="item in vacationCreditDetailList"
              :key="item.expireDate"
            >
              {{ item.remainDays }} day(s) expire on {{ item.expireDate }}
            </div>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { TreeSelect } from 'ant-design-vue'
import { BOverlay } from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import { getDicts, flattenArray } from '../utils'
import { hasChildren } from './utils'
import StaffInfo from './staffInfo.vue'
import deptPannel from './pannelByDictCode/dept.vue'
import projectPannel from './pannelByDictCode/project.vue'

export default {
  components: {
    // vSelect,
    TreeSelect,
    BOverlay,
    StaffInfo,
    deptPannel,
    projectPannel,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    vacationCreditDetailList: {
      type: Array,
      default: () => [],
    },
    itemData: {
      type: Object,
      default: () => ({}),
    },
    dictValue: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
  },
  data() {
    return {
      parentID: '',
      data: undefined,
      dictOptions: [],
      dictCode: this.option.dictCode || this.option.dictBizCode,
      loading: false,
      multipleData: [],
      multiple: this.option.multiple || false,
      onlySelectChildren: this.option.onlySelectChildren,
      updateNow: this.option.updateNow || false,
    }
  },
  computed: {
    staffInfo() {
      const staffInfo = this.option.staffInfo || {}
      if (staffInfo.show) {
        return staffInfo
      }
      return false
    },
    pannelParams() {
      if (['dept', 'project'].includes(this.option.dictCode)) {
        return {
          id: this.data,
        }
      }
      return {}
    },
    isCustomPannel() {
      return (
        ['dept', 'project'].includes(this.option.dictCode) &&
        this.option.customPannel
      )
    },
    allowClear() {
      if (this.option.allowClear === undefined) {
        return true
      }
      return this.option.allowClear
    },
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        if (Array.isArray(e)) {
          this.$emit('input', e)
        } else if (typeof e === 'object') {
          if (!e) {
            this.$emit('input', undefined)
          } else {
            this.$emit('input', e.value)
          }
        } else {
          this.$emit('input', e)
        }
      },
    },
    value: {
      handler(e) {
        this.data = e
        if (e || !this.disabled) {
          this.initDictOption(e === -1 || e === '-1' ? null : e)
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictData': {
      handler(e) {
        if (e) {
          if (e.length > 0) {
            this.dictOptions = e
          }
        }
      },
      immediate: true,
    },
    'option.dictQuery': {
      deep: true,
      handler(e, old) {
        if (JSON.stringify(e) !== JSON.stringify(old)) {
          this.dictOptions = []
          this.initDictOption(null, true)
        }
      },
    },
    'option.dictBizCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.parentID = String(Math.random())
  },
  methods: {
    hasChildren,
    initDictOption(e, notChangeData) {
      let toStringVal = ''
      if (this.multiple) {
        const temp = e || []
        toStringVal = typeof temp === 'string' ? temp.split(',') : temp
      } else {
        toStringVal = e ? e.toString() : e
      }
      if (this.dictCode && this.dictOptions.length <= 0) {
        this.loading = true
        getDicts(this.option).then((res) => {
          this.dictOptions = res
          if (this.onlySelectChildren) {
            console.log(this.dictOptions)
          }
          if (!notChangeData) {
            this.data = toStringVal || undefined
          }
          this.loading = false
        })
      } else if (toStringVal) {
        this.data = toStringVal
      }
    },
    changeDictOption() {
      getDicts(this.option).then((res) => {
        this.dictOptions = res
      })
    },
    findTreeSelectLabel(value, dicts) {
      const arr = flattenArray(dicts)
      const findData = arr.find((o) => o.value === value) || {}
      return findData.label || this.dictValue
    },
    findSelectLabel(value, dicts) {
      if (this.multiple) {
        const res = []
        if (Array.isArray(value)) {
          value.forEach((item) => {
            const findData = dicts.find((o) => o.value === item) || {}
            res.push(findData.label)
          })
        }
        return res.join() || this.dictValue
      }
      const findData = dicts.find((o) => o.value === value) || {}
      return findData.label || this.dictValue
    },
    handleChange(e) {
      this.data = e
    },
    filterOption(input, option) {
      const CIndexOf = (str1, str2) =>
        str1.toUpperCase().includes(str2.toUpperCase())
      const { title } = option.componentOptions.propsData
      return CIndexOf(title, input)
    },
  },
}
</script>

<!-- <style lang='scss'>
@import '@core/scss/vue/libs/vue-select.scss';

</style> -->
<style lang="scss">
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.dark-layout {
  .ant-select .ant-select-selection {
    border-color: $theme-dark-input-border-color;
    background-color: $theme-dark-input-bg;
    .ant-select-selection__placeholder,
    .ant-select-search__field__placeholder {
      color: $theme-dark-input-placeholder-color;
    }
  }
}

.ant-select {
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: $primary;
    box-shadow: 0 3px 10px 0 rgb(34 41 47 / 10%);
  }
  .ant-select-selection {
    height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    .ant-select-selection__rendered {
      line-height: 2.714rem;
    }
    &:hover {
      border-color: #d9d9d9;
    }
  }
  .ant-select-selection--multiple {
    height: auto;
    padding-bottom: 0;
    min-height: auto;
    .ant-select-selection__rendered {
      transform: translateY(-11px);
    }
  }
}
.vacationTip {
  color: #6e6b7b;
  font-size: 12px;
}
</style>
